import {isMobile} from '../../../../../commons/selectors/environment'
import {getListButtonStyle, getComponentConfig} from '../../selectors/settings'
import {hasEventDetailsUrl} from '../../selectors/events'
import {AppProps} from '../app/interfaces'
import {connect} from '../runtime-context/connect'
import {RsvpButton as RsvpButtonPresentation} from './rsvp-button'
import {ButtonOwnProps, ButtonStateProps} from './interfaces'

const mapRuntime = ({state, actions}: AppProps, {event}: ButtonOwnProps): ButtonStateProps => ({
  navigateToPage: () => actions.navigateToPage(event),
  mobile: isMobile(state),
  style: getListButtonStyle(getComponentConfig(state)),
  hasUrl: hasEventDetailsUrl(state, event),
  settings: getComponentConfig(state).settings,
})

export const RsvpButton = connect<ButtonOwnProps, ButtonStateProps>(mapRuntime)(RsvpButtonPresentation)

export * from './interfaces'
